import React from 'react';

const gradeColor = (g) => {
  if (g >= 8) return '#00E676';
  if (g >= 7) return '#00C853';
  if (g >= 6) return '#FFD600';
  if (g >= 4) return '#FFB300';
  return '#EF5350';
};

const StrengthsPanel = ({ strengths }) => {
  return (
    <div className="panel-card fade-in delay-200">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-1 h-6 bg-[#00E676] rounded"></div>
        <h2 className="text-white font-bold text-base">Top Strengths</h2>
      </div>

      <div className="flex flex-col gap-2">
        {strengths.length === 0 ? (
          <div className="text-center py-4 text-[#546E7A] text-sm">
            No categories scoring 7+ yet
          </div>
        ) : (
          strengths.map((strength, index) => (
            <div key={index} className="flex items-center justify-between px-2 py-2 rounded-lg bg-[#243B55]/40">
              <span className="text-[#B0BEC5] text-sm">{strength.name}</span>
              <span className="font-rajdhani font-bold text-lg" style={{ color: gradeColor(strength.score) }}>
                {strength.score}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default StrengthsPanel;
